import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useState, useEffect } from "react";
import Modal from "react-modal";
import '../../styles/Buttons.css';
import '../../styles/Containers.css';
import '../../styles/Fonts.css';
import '../../styles/Colors.css';
import TopNavbarBack from '../../components/TopNavbarBack';
import AddToHomeScreenButton from './components/AddToHomeScreenButton';
import AccountEmptyState from './components/AccountEmptyState';
import GoToTop from '../../components/GoToTop';
import logout from "../../media/logout.png";
import { useFetch } from '../../custom/api';

export default function Menu() {
  const navigation = useNavigate();
  const { myFetch } = useFetch();
  const isLoggedIn = !!localStorage.getItem('token');
  let userInfo = JSON.parse(localStorage.getItem('userInfo'));
  const [name, setName] = useState("");
  const [displayName, setDisplayName] = useState(name);
  const [dClassName, setDClassName] = useState('dNone');


  const logOutHandler = async () => {

    const resp = await myFetch(`logout`, {method: "GET"});
    const r = await resp.json()
    if (resp.status ===200){
      localStorage.removeItem("token");
      localStorage.removeItem("userInfo");
      navigation("/login");

    }

  }

  
  const [showCModal, setShowCModal] = useState(false);

  const handleOpenCModal = () => {
    setShowCModal(true);
  };

  const handleCloseCModal = () => {
    setShowCModal(false);
  };

  useEffect(() => {
      if (!isLoggedIn) return;
      const fetchData = async () => {
        const resp = await myFetch("account", { method: "GET" });
        const r = await resp.json();
        setName(r[0].name)
        setDisplayName(r[0].name)
      };
      fetchData();
    }, []);

    useEffect(() => {
      console.log({name, displayName})
      if (name === displayName) {
        setDClassName('dNone')
      } else {
        setDClassName('')
      };
      
    }, [displayName])

  if (!isLoggedIn) {
    return (
      <AccountEmptyState
        title="منو اینجا منتظرته"
        caption="وارد حسابت شو تا به حساب کاربری، اشتراک و تنظیماتت دسترسی داشته باشی."
      />
    );
  }

  return (
    <div className="backDarkColor">
      <TopNavbarBack
        title=""
        rbuttonIcon={['icon-iconchevron-right']}
        rbackground={['rectangle2']}
        lbuttonIcon={['dNone']}
        lbuttonHref={['null']}
        lbackground={['null']}
      />

      <div className="main-container">
        <div className="heading-3 white">
          {/* <span className="icon-iconpicture heading-1"></span> */}
          <p>فودپلنری گرامی</p>
          <p>{displayName}</p>
        </div>

        <div className="marginBottom60">

          <Link to="/account" className="withIcon1">
            <p className="box32">
              <span className="icon-iconuser heading-2 grey-3"></span>
            </p>
            <p className="yekan subject-1">حساب کاربری</p>
          </Link>

          <Link to="/achievements" className="withIcon1">
            <p className="box32">
              <span className="icon-iconstar heading-2 grey-3"></span>
            </p>
            <p className="yekan subject-1">دستاوردها</p>
          </Link>

          <Link to="/community" className="withIcon1">
            <p className="box32">
              <span className="icon-iconteam heading-2 grey-3"></span>
            </p>
            <p className="yekan subject-1">انجمن</p>
          </Link>

          <Link to="/subscription" className="withIcon1">
            <p className="box32">
              <span className="icon-icongift heading-2 grey-3"></span>
            </p>
            <p className="yekan subject-1">خرید اشتراک</p>
          </Link>

          <AddToHomeScreenButton />

          <Link to="" className="withIcon1" onClick={handleOpenCModal}>
            <p className="box32">
              <span className="icon-iconlog-out heading-2 grey-3 "></span>
            </p>
            <p className="yekan subject-1">خروج</p>
          </Link>
        </div>

        <div className="yekan caption-1 white">
          <p>ساخته شده با عشق در فودپلنر</p>
          <p>نسخه 1.2</p>
        </div>
      </div>

      <Modal
        isOpen={showCModal}
        onRequestClose={handleCloseCModal}
        contentLabel="Date Picker Modal"
        className="modal"
        overlayClassName="overlay"
      >
        <div className="modal-header">
          <img src={logout} className="marginR14" alt="logout" />
        </div>
        <div className="modal-body">
          <h2>
           میخوای از حسابت خارج شی؟
          </h2>
        </div>
        <div className="modal-footer">
          <Link
            to=""
            onClick={logOutHandler}
            className="marginBottom0-4r b-red-1 fill-container radius1-5"
          >
            آره خارج میشم
          </Link>
          <Link
            to=""
            onClick={handleCloseCModal}
            className="b-grey-4 grey-1 fill-container radius1-5"
          >
            منصرف شدم
          </Link>
        </div>
      </Modal>

      <GoToTop />
    </div>
  );
}
